import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	caledarTitle: {
		id: 'servicedesk-sla-settings.calendars.modal.caledar-title',
		defaultMessage: 'Calendars',
		description: 'title for calendar modal',
	},
	addCalendar: {
		id: 'servicedesk-sla-settings.calendars.modal.add-calendar',
		defaultMessage: 'Add calendar',
		description: 'button message to add calendar',
	},
});
